import Grid from '@mui/material/GridLegacy';
import ReactMarkdown from 'react-markdown';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import MarkdownLinkRenderer from '../shared/MarkdownLinkRenderer';
import MarkdownParagraphRenderer from '../shared/MarkdownParagraphRenderer';
import useIsMobile from '../../hooks/useIsMobile';
import MarkdownUnorderListRenderer from '../shared/MarkdownUnorderedListRenderer';
import MarkdownListItemRenderer from '../shared/MarkdownListItemRenderer';

const FitnessPageSection = ({ sectionData, index }) => {
	const { imageUrl, title, body } = sectionData;
	const isMobile = useIsMobile();

	return (
		<Grid container columnSpacing={{ md: 9 }} mb={{ xs: 2, md: 4 }}>
			{(index % 2 === 1 || isMobile) && (
				<Grid item xs={12} md={5}>
					<img src={imageUrl} alt={title} width='100%' />
				</Grid>
			)}
			<Grid item xs={12} md={7}>
				<Typography
					component='h2'
					variant='h4'
					mb={3}
					mt={{ xs: 3, md: 0 }}
				>
					{title}
				</Typography>
				<ReactMarkdown
					components={{
						a: MarkdownLinkRenderer,
						p: MarkdownParagraphRenderer,
						ul: MarkdownUnorderListRenderer,
						li: MarkdownListItemRenderer,
					}}
				>
					{body}
				</ReactMarkdown>
			</Grid>
			{index % 2 === 0 && !isMobile && (
				<Grid item xs={12} md={5}>
					<img src={imageUrl} alt={title} width='100%' />
				</Grid>
			)}
		</Grid>
	);
};

FitnessPageSection.propTypes = {
	sectionData: PropTypes.object.isRequired,
	index: PropTypes.number.isRequired,
};

export default FitnessPageSection;
